import { render, staticRenderFns } from "./ContentTiktok.vue?vue&type=template&id=84254bec&"
import script from "./ContentTiktok.vue?vue&type=script&lang=js&"
export * from "./ContentTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports